module.exports = __webpack_public_path__ + "static/img/1_4.53f4b86b.jpg";